import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import { ImportDetails } from 'assets//js/pages/account-settings/imports/ImportDetails';
import Content from 'assets/js/components/Content';
import { AccountAboutRouter } from 'assets/js/pages/account-settings/account-about/AccountAboutRouter';
import { IntegrationsRouter } from 'assets/js/pages/account-settings/account-integrations';
import { SettingsRouter } from 'assets/js/pages/account-settings/account-settings/SettingsRouter';
import { ImportsRouter } from 'assets/js/pages/account-settings/imports-router/ImportsRouter';
import { AccountMembersRouter } from 'assets/js/pages/account-settings/users/AccountMembersRouter';
import { PermissionErrorBoundary } from 'components/error-boundaries/PermissionErrorBoundary';
import { Permissions } from 'components/permissions';
import {
    AccountMemberPermission,
    AccountPermission,
    ImportPermission,
} from 'components/permissions/PermissionEnums';
import { Route } from 'components/router/Route';
import * as SubNav from 'components/sub-nav';
import { SettingsSubNavTabs } from 'components/sub-nav/SettingsSubNavTabs';

const AccountSettingsRoutes = {
    About: 'about',
    Users: 'users',
    Integrations: 'integrations',
    Settings: 'settings',
    Imports: 'imports',
};

const DefaultRoute = AccountSettingsRoutes.About;

export const AccountSettings = () => {
    const match = useRouteMatch();
    return (
        <Content>
            <div className="flex flex-col gap-4">
                <SubNav.Root>
                    <SubNav.Header>
                        <SubNav.Title>Settings</SubNav.Title>
                    </SubNav.Header>
                    <SettingsSubNavTabs />
                </SubNav.Root>

                <PermissionErrorBoundary>
                    <Switch>
                        <Route path={`${match.path}/${AccountSettingsRoutes.About}`}>
                            <AccountAboutRouter />
                        </Route>
                        <Route path={`${match.path}/${AccountSettingsRoutes.Settings}`}>
                            <SettingsRouter />
                        </Route>
                        <Route path={`${match.path}/${AccountSettingsRoutes.Integrations}`}>
                            <Permissions
                                allowed={[AccountPermission.INTEGRATIONS]}
                                fallback={<Redirect to={`${match.url}/${DefaultRoute}`} />}
                            >
                                <IntegrationsRouter />
                            </Permissions>
                        </Route>
                        <Route path={`${match.path}/${AccountSettingsRoutes.Users}`}>
                            <Permissions
                                allowed={[AccountMemberPermission.VIEW]}
                                fallback={<Redirect to={`${match.url}/${DefaultRoute}`} />}
                            >
                                <AccountMembersRouter />
                            </Permissions>
                        </Route>
                        <Route
                            exact={true}
                            path={`${match.path}/${AccountSettingsRoutes.Imports}/:import_id(\\d+)`}
                        >
                            <Permissions
                                allowed={[ImportPermission.VIEW]}
                                fallback={<Redirect to={`${match.url}/${DefaultRoute}`} />}
                            >
                                <ImportDetails />
                            </Permissions>
                        </Route>
                        <Route path={`${match.path}/${AccountSettingsRoutes.Imports}`}>
                            <Permissions
                                allowed={[ImportPermission.VIEW]}
                                fallback={<Redirect to={`${match.url}/${DefaultRoute}`} />}
                            >
                                <ImportsRouter />
                            </Permissions>
                        </Route>
                        <Route>
                            <Redirect to={`${match.url}/${DefaultRoute}`} />
                        </Route>
                    </Switch>
                </PermissionErrorBoundary>
            </div>
        </Content>
    );
};

export default AccountSettings;
